import { render, staticRenderFns } from "./SetupReferral.vue?vue&type=template&id=f76d06d8&scoped=true&"
import script from "./SetupReferral.vue?vue&type=script&lang=ts&"
export * from "./SetupReferral.vue?vue&type=script&lang=ts&"
import style0 from "./SetupReferral.vue?vue&type=style&index=0&id=f76d06d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76d06d8",
  null
  
)

export default component.exports